const CSC_ORIGIN = document.location.ancestorOrigins?.[0] ?? "";

/**
 * Resize outerIFrame to `width` and `height` pixels
 * // TODO rename to width, height
 * @param param0
 */
export function resizeOuterIFrame({ width, height }: { width: number; height: number }) {
	const message = {
		event: "resize",
		scrollWidth: width,
		scrollheight: height,
	};

	window.parent.postMessage({ ...message, noScroll: true }, CSC_ORIGIN);
}

export function filterSettledPromises<T>(results: PromiseSettledResult<T>[]): T[] {
	return results
		.filter((result): result is PromiseFulfilledResult<T> => result.status === "fulfilled")
		.map((result) => result.value);
}

export function filterDefined<T>(results: (T | undefined)[]): T[] {
	return results.filter((result): result is T => result !== undefined);
}
